import { Star } from '@mui/icons-material';
import styles from './SectionDivider.module.scss';

const SectionDivider = ({ color = '#1a237e' }) => {
  return (
    <div className={styles.divider}>
      <div className={styles.divider__line} style={{ backgroundColor: color }}></div>
      <Star className={styles.divider__icon} style={{ color }} />
      <div className={styles.divider__line} style={{ backgroundColor: color }}></div>
    </div>
  );
};

export default SectionDivider; 